<template>
    <div class="Com_1">
      <title1 type="1" title="光伏电站运营情况"/>
      <title1 type="2" title="站点信息">
        <template v-slot:tab>
          <div class="title-3"></div>
        </template>
      </title1>
      <div class="bottom">
          <div class="left">
            <img class="photovoltaicImg" src="@/assets/images/photovoltaic/photovoltaicBack.png" alt="">
          </div>
<!--          <div class="right">
            <div class="rightBox">
              <div class="box_1">
							  <div class="name-title">
							    {{infoObj.station_name}}
							  </div>
                <div class="row_2">
                  <div class="iconName"><span class="icon"></span><span class="name">省市</span></div>
                  <span>{{infoObj.city}}</span>
                </div>
                <div class="row_2">
                  <div class="iconName"><span class="icon"></span><span class="name">占地面积</span></div>
                  <span>{{infoObj.floorspace}}</span>
                </div>
                <div class="row_2">
                  <div class="iconName"><span class="icon"></span><span class="name">装机容量</span></div>
                  <span>{{infoObj.rated_capacity}}</span>
                </div>
								<div class="row_2">
								  <div class="iconName"><span class="icon"></span><span class="name">光伏板数量</span></div>
								  <span>{{infoObj.pvquantity}}</span>
								</div>
								<div class="row_2">
								  <div class="iconName"><span class="icon"></span><span class="name">建站日期</span></div>
								  <span>{{infoObj.market_time}}</span>
								</div>
              </div>
            </div>
          </div>-->
		      <div
			      :style="{
							flex: 1,
			        display: 'flex',
			        flexDirection: 'column',
			        justifyContent: 'center'
		        }"
		      >
			      <div
				      :style="{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '12px'}"
			      >
				      <b
					      :style="{
									position: 'relative',
									lineHeight: '27px',
									fontSize: '30px',
									overflow: 'hidden', //超出隐藏
									textOverflow: 'ellipsis', //显示省略号
									whiteSpace: 'nowrap' //强制不换行
								}"
				      >{{infoObj.station_name}}</b>
				      <div
					      :style="{
									flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start',
									gap: '10px',
									fontSize: '18px', color: '#51dbdb',
									marginTop: '8px'
								}"
				      >
					      <div :style="{position: 'relative', width: '52.6px', height: '28px'}">
						      <img
							      :style="{position: 'absolute', height: '100%', width: '100%', top: '0%', right: '0%', bottom: '0%', left: '0%', maxWidth: '100%', overflow: 'hidden', maxHeight: '100%', objectFit: 'contain'}"
							      alt=""
							      src="https://sass.gclme.com/api/file/Image/annex/20231228_b98995e2297440f39a11549c7e83642a.png"
						      />
						      <div
							      :style="{position: 'absolute', top: '1px', left: '7.6px', lineHeight: '26px'}"
						      >
							      {{/* arrObj.runningstate*/ }}
							      正常
						      </div>
					      </div>
					      <div
						      :style="{position: 'relative', height: '28px', color: '#f3d68e'}"
					      >
						      <img
							      :style="{
											position: 'absolute',
										  height: '100%', width: '100%',
										  objectFit: 'fill',transform: 'scale(1.2,1)'
										}"
							      alt=""
							      src="https://sass.gclme.com/api/file/Image/annex/20231228_58cbfbc6ba18435b9dce9a0f8faa67ca.png"
						      />
						      <div
							      :style="{lineHeight: '26px'}"
						      >
							      {{ infoObj.photovoltaic_type }}
						      </div>
					      </div>
				      </div>
			      </div>
			      <div
				      :style="{
								display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start',
								gap: '12px',
								fontSize: '18px', color: 'rgba(255, 255, 255, 0.7)',
								marginTop: '28px'
							}"
			      >
				      <div
					      :style="{flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start'}"
				      >
					      <div :style="{position: 'relative', lineHeight: '26px'}">
						      城市：
					      </div>
					      <div
						      :style="{position: 'relative', lineHeight: '26px', color: 'rgba(255, 255, 255, 0.9)'}"
					      >
						      {{infoObj.city}}
					      </div>
				      </div>
				      <div
					      :style="{flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start'}"
				      >
					      <div :style="{position: 'relative', lineHeight: '26px'}">
						      占地面积：
					      </div>
					      <div
						      :style="{position: 'relative', lineHeight: '26px', color: 'rgba(255, 255, 255, 0.9)'}"
					      >
						      {{infoObj.floorspace}}
					      </div>
				      </div>
				      <div
					      :style="{flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start'}"
				      >
					      <div :style="{position: 'relative', lineHeight: '26px'}">
						      装机容量：
					      </div>
					      <div
						      :style="{position: 'relative', lineHeight: '26px', color: 'rgba(255, 255, 255, 0.9)'}"
					      >
						      {{infoObj.rated_capacity}}
					      </div>
				      </div>
				      <div
					      :style="{flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start'}"
				      >
					      <div :style="{position: 'relative', lineHeight: '26px'}">
						      光伏板数量：
					      </div>
					      <div
						      :style="{position: 'relative', lineHeight: '26px', color: 'rgba(255, 255, 255, 0.9)'}"
					      >
						      {{infoObj.pvquantity}}
					      </div>
				      </div>
				      <div
					      :style="{flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start'}"
				      >
					      <div :style="{position: 'relative', lineHeight: '26px'}">
						      建站日期：
					      </div>
					      <div
						      :style="{position: 'relative', lineHeight: '26px', color: 'rgba(255, 255, 255, 0.9)'}"
					      >
						      {{infoObj.market_time&&infoObj.market_time.split(" ")[0]}}
					      </div>
				      </div>
			      </div>
		      </div>
      </div>
    </div>
  </template>
  
  <script>
  import title1 from "@/views/exposition/components/title3";
  import { dataInterface } from "@/api/dataInterfaceApi";
  export default {
    components: {
      title1,
    },
    data() {
      return {
        infoObj: {}
      };
    },
    methods: {
      serverOverview() {
        let params1 = {
          "enCode": "zngf-dz-zhandianxinxi-zuoshang",// 接口code
           "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
        };
        dataInterface
          .dataFaceApi(params1)
          .then((res) => {
            console.log(res, "站点信息");
             if(res) {
							 this.infoObj = res[0]
						 }
          })
          .catch((err) => {
            console.log(err);
          });
      },
    },
    destroyed() {
      // this.$bus.$off('onfangdiangonglv')
    },
    mounted() {
      this.serverOverview();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import "@/views/components/energyStorage/comm.scss";
  
  .Com_1 {
    .title-3{
        width: 35%;
        height: 90%;
        background: url(~@/assets/images/myComm/title-3-3.png) left bottom no-repeat;
        background-size: 100% 54px; 
        float: right;
    }
    .bottom {
      height: 410px;
      width: 565px;
      // background: red;
      display: flex;
      .left{
        width: 345px;
        height: 410px;
        display: flex;
        align-items: center;
        .photovoltaicImg{
          width: 100%;
          // height: 100%;
        }
      }
      .right{
        flex: 1;
        // background: red;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .rightBox{
          width: 220px;
          height: 246px;
          // background: skyblue;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
		  margin-top: 45px;
          .box_1{
            width: 220px;
            height: 176px;
            // background: orange;
			.name-title{
				font-size: 20px;
				font-weight: 600;
				color: #ffffff;
			}
            .row_1,.row_2{
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .row_1{
              color: rgba(255, 255, 255, 0.90);
              .name{
                font-size: 18px;
              }
              .number{
                font-size: 24px;
              }
            }
            .row_2{
              margin-top: 15px;
              color: rgba(255, 255, 255, 0.70);
            }
          }
          .box_2{
            width: 220px;
            height: 54px;
            // background: pink;
            .row_3{
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              color: rgba(255, 255, 255, 0.90);
              .name{
                font-size: 18px;
              }
                .number{
                  font-size: 24px;
                }
            }
          }
        }
      }
      .num {
        padding-left: 10px;
        font-size: 24px;
        font-family: "HT";
        color: #00ffff;
      }
      .text{
          letter-spacing: 3px;
          font-family: 'PMZD';
        }
    }
  }
  
  </style>